import React, { useState, useCallback } from 'react';
import { GuidePageWrapper, GuideBody } from '../components/Guide/Guide.styles';
import { GuideSidebar } from '../components/Guide/GuideSidebar';
import { GuideContent } from '../components/Guide/GuideContent';
import { GUIDE_SECTIONS } from '../components/Guide/guideSections';

export const GuidePage: React.FC = () => {
  const [activeSection, setActiveSection] = useState(GUIDE_SECTIONS[0].id);

  const handleSectionClick = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const handleActiveSectionChange = useCallback((id: string) => {
    setActiveSection(id);
  }, []);

  return (
    <GuidePageWrapper>
      <GuideBody>
        <GuideSidebar activeSection={activeSection} onSectionClick={handleSectionClick} />
        <GuideContent onActiveSectionChange={handleActiveSectionChange} />
      </GuideBody>
    </GuidePageWrapper>
  );
};
